import BaseController from './base';

export default class extends BaseController {
  static targets = ['navBar'];

  navBarTargetConnected(el) {
    this.navBar = el;
  }

  toggleMenu() {
    this.navBar.classList.toggle('d-none');
  }
}
